import { Row } from 'react-bootstrap';
import { Healthpage } from './healthSection/healthpage';
import { Footer } from '../footer';
import { Navbar } from '../navbar';

const Health = () => {
	return (
		<div>
			<Row>
			<Navbar />
			< Healthpage />
			< Footer />
			</Row>
		</div>
	);
};
export { Health };
